import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { IDocumentImporterTableRowProps } from '../../document-importer-list.interfaces';

const DocumentImporterTableRowActions = ({
  record,
  handleModals,
  t,
}: IDocumentImporterTableRowProps) => {
  return (
    <Popover
      elements={[
        {
          label: t('documentImporter:buttons.preview'),
          key: ICONS.foodMenu,
          icon: ICONS.foodMenu,
          handler: () => {
            handleModals(record);
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default DocumentImporterTableRowActions;
